import { store } from 'app/shared/store/store';
import { featureApiService } from 'app/shared/services/feature/featureApi-service';
import { FeatureStatus } from 'app/shared/models/feature-status.model';
import { FeatureKey } from 'app/shared/models/feature-key';

class FeatureService {
  public getFeatureStatus(key: FeatureKey): boolean {
    const featureFlagStatus: FeatureStatus = store.get('featureStatus') || {};
    return featureFlagStatus[key] || false;
  }

  public async loadFeatureStatus(key: FeatureKey): Promise<boolean> {
    let featureFlagStatus: FeatureStatus = store.get('featureStatus') || {};

    // Check if key is 'undefined'. Don't use '!featureFlagStatus[key]' as if value is 'false' then it will invoke API search
    if (featureFlagStatus[key] === undefined) {
      featureFlagStatus = await this.loadFeaturesStatus([key]);
    }

    return featureFlagStatus && featureFlagStatus[key];
  }

  public async loadFeaturesStatus(featureKeys: FeatureKey[]): Promise<FeatureStatus> {
    if (featureKeys === null || featureKeys.length === 0) {
      throw 'Invalid Argument featureKeys';
    }

    // Load requested feature flags
    const featureStatus = await this.getFeatureFlagStatus(featureKeys);

    // Update Store with Feature Flags status
    const existingFeatureStatus = store.get('featureStatus') || {};
    const combinedFeatureStatus = Object.assign(existingFeatureStatus, featureStatus);
    store.set('featureStatus', combinedFeatureStatus);

    // Return status for requested feature flags
    return featureStatus;
  }

  private async getFeatureFlagStatus(featureKeys: FeatureKey[]): Promise<FeatureStatus> {
    return await featureApiService.getFeatureFlagStatus(featureKeys);
  }
}

export const featureService = new FeatureService();
